<template>
  <div class="content">
    <div class="box">
      <div class="map" id="container">
        <baidu-map
          class="bm-view"
          :center="formData.shopAdress"
          :zoom="zoom"
          
          @ready="handler"
        >
          <bm-geolocation
            anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
            :showAddressBar="true"
            :autoLocation="true"
          ></bm-geolocation>
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
          <bm-marker :position="{lng: 116.404, lat: 39.915}" :dragging="false" @mouseover="infoWindowOpen" @mouseout="infoWindowClose" animation="BMAP_ANIMATION_BOUNCE">
      <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">{{formData.shopAdress}}</bm-info-window>
    </bm-marker>
        </baidu-map>

        <!-- <img class="ditu" src="../../assets/images/ditu.png" alt="" /> -->
      </div>
      <div class="information">
        <span class="contype">联系方式</span>
        <div class="people" v-if="formData.chargePersonName">
          <i class="icon-add14"></i>
          <span class="mingzi">联系人: </span>
          <span class="mingzi">{{ formData.chargePersonName }}</span>
        </div>
        <div class="people" v-if="formData.chargePersonPhone">
          <i class="icon-add13"></i>
          <span class="mingzi">联系电话: </span>
          <span class="mingzi">{{ formData.chargePersonPhone }}</span>
        </div>
        <!-- <div class="email">
          <i class="icon-add112"></i>
          <span class="em">电子邮箱</span>
          <span class="emai">30403432@qq.com</span>
        </div> -->
        <!-- <div class="qq">
          <i class="icon-add114"></i>
          <span class="qqmingzi">QQ</span>
          <span class="qqnumber">1534245453</span>
        </div> -->
        <div class="people" v-if="formData.shopWechat">
          <i class="icon-add17"></i>
          <span class="mingzi">微信: </span>
          <span class="mingzi">{{ formData.shopWechat }}</span>
        </div>
        <!-- <el-form label-width="80px">
          <el-form-item label="联系人" class="icon-The-user-name">
            <span>张三</span>
          </el-form-item>
          <el-form-item label="电话号码">
            <span>17825634218</span>
          </el-form-item>
          <el-form-item label="电子邮箱">
            <span>17825634218@qq.com</span>
          </el-form-item>
          <el-form-item label="QQ ">
            <span>张三</span>
          </el-form-item>
          <el-form-item label="微信">
            <span>17825634218</span>
          </el-form-item>
        </el-form> -->
        <div class="possition" v-if="formData.shopAdress">
          <span class="contype">联系地址</span>
          <div class="people">
            <i class="icon-positioning"></i>
            <span class="mingzi">地址: </span>
            <span class="mingzi">{{ formData.shopAdress }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import { listSearchMixin } from "../../config/mixin";
import { mapGetters, mapMutations } from "vuex";
//百度地图
import BaiduMap from "vue-baidu-map/components/map/Map.vue";

export default {
  mixins: [listSearchMixin],
  components: {
    BaiduMap,
  },
  data() {
    return {
      imgList: [],

      formData: {},
      index: "1",
      classifyTitle: "",
      shopClassifyList: [],
      shopId: null,
      productList: [],
      shopName: null,
      shopLogo: null,
      total: 0,
      type: "",
      volume: "",
      page: 1,
      pageSize: 12,
      item: [],
      maxMoney: "",
      minMoney: "",
      shopIntroduce: "",
      keyword: "",
      setCollectData: "",
      center: { lng: 0, lat: 0 },
      zoom: 3,
      location: '保山市',
      show:true
    };
  },
  computed: {
    ...mapGetters(["collectData"]),
    // ...mapMutations({
    //   setSearchObj: "SET_SEARCHOBJ",
    // }),
  },
  mounted() {
    this.shopId = parseInt(this.$route.query.shopId);
    this.getShopInfo();
    this.getMap();
    // this.getEnterpriseCheckData();
  },
  methods: {
    infoWindowClose () {
      this.show = false
    },
    infoWindowOpen () {
      this.show = true
    },
    handler({ BMap, map }) {
      console.log(BMap, map);
      this.center.lng = 116.404;
      this.center.lat = 39.915;
      this.zoom = 15;
    },
    // 获取店铺首页
    getShopInfo() {
      let params = {
        url: api.getShopIndex + `?shopId=${this.shopId}`,
        method: "GET",
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          this.formData = res.data;
          this.shopName = res.data.shopName;
          this.shopIntroduce = res.data.shopIntroduce;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
  },
};
</script>
<style  lang = 'scss' scoped>
.bm-view {
  width: 800px;
  height: 450px;
}
.content {
  background: #f6f6f6;
}
.box {
  width: 100%;
  display: flex;
  margin: 20px 0;
  background: white;
  justify-content: space-between;
}
.map {
  /* width: 55%; */
  width: 800px;
  height: 500px;
  /* margin-top: 50px; */
  /* margin-left: 50px; */
  /* height: 477px; */
  padding: 20px;
  img {
    width: 100%;
  }
}

.information {
  float: right;
  margin-top: 100px;
  margin-left: 100px;
  width: 40%;
}
.possition {
  margin-top: 30px;
}
.adress {
  margin-top: 20px;
  .icon-positioning-2 {
  }
  .dizhi {
    margin-left: 30px;
  }
}
.mingzi {
  margin-left: 10px;
}
.people {
  font-size: 18px;
}
.contype {
  width: 72px;
  height: 24px;
  font-size: 20px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #000000;
  margin-left: 1px;
  padding-top: 20px;
}
.people {
  margin-top: 10px;
  .icon-The-user-name {
  }
  .ren {
    margin-left: 10px;
  }
  .mingzi {
    /* margin-left: 10px; */
    display: inline-block;
    /* width: 100px; */
  }
}
.tel {
  margin-top: 10px;
  .icon-add13 {
  }
  .haoma {
    margin-left: 30px;
  }
  .phone {
    margin-left: 10px;
  }
}
.email {
  margin-top: 10px;
  .icon-add112 {
  }
  .em {
    margin-left: 10px;
  }
  .emai {
    margin-left: 30px;
  }
}
.qq {
  margin-top: 10px;
  .icon-add114 {
  }
  .qqmingzi {
    margin-left: 10px;
  }
  .qqnumber {
    margin-left: 30px;
  }
}
.wechat {
  margin-top: 10px;
  .icon-add17 {
  }
  .wechatmingzi {
    margin-left: 10px;
  }
  .wechatnumber {
    margin-left: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/canvasShow/contact.vue